import React from 'react';
import clsx from "clsx";
import './Button.scss';

const Button = ({children, ...props}) => {
    return <button className={clsx({
        primary: props.className === 'primary',
        secondary: props.className === 'secondary',
        tertiary: props.className === 'tertiary',
        small: props.className === 'small',
        large: props.className === 'large',
        delete: props.className === 'delete',
    })} {...props}>{children}</button>;
};

export default Button;
